import type { SVGProps } from "react";
import * as React from "react";
import { type iconSize, iconSizeVariants } from "@remi/types/icons";

type SvgIconProps = SVGProps<SVGSVGElement> & {
  size?: iconSize;
};
const Happy = ({ size = "sm", ...props }: SvgIconProps) => {
  props.width = iconSizeVariants[size];
  props.height = iconSizeVariants[size];
  return (
    <svg {...props} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M10.1016 9.44336C10.2968 9.24811 10.6143 9.24715 10.8096 9.44238C11.0046 9.63752 11.0044 9.95415 10.8096 10.1494L10.4551 9.7959C10.8086 10.1495 10.8087 10.1502 10.8086 10.1504L10.8018 10.1572C10.7987 10.1602 10.7945 10.1638 10.79 10.168C10.7804 10.1771 10.767 10.1898 10.751 10.2041C10.7182 10.2334 10.6718 10.2735 10.6133 10.3193C10.4961 10.411 10.3263 10.5301 10.1094 10.6484C9.67513 10.8852 9.04134 11.123 8.25 11.123C7.45877 11.123 6.82488 10.8852 6.39062 10.6484C6.17352 10.5301 6.00396 10.411 5.88672 10.3193C5.82808 10.2735 5.7818 10.2343 5.74902 10.2051C5.73278 10.1906 5.71971 10.1782 5.70996 10.1689C5.70508 10.1643 5.70048 10.1604 5.69727 10.1572C5.69569 10.1557 5.69453 10.1535 5.69336 10.1523L5.69141 10.1514L5.69043 10.1504C5.69034 10.1502 5.69311 10.147 5.87988 9.95996L5.69043 10.1504C5.4955 9.95527 5.49562 9.63764 5.69043 9.44238C5.86135 9.2716 6.12528 9.25061 6.31934 9.37891L6.39746 9.44238C6.40049 9.44525 6.40624 9.45113 6.41504 9.45898C6.43286 9.4749 6.46264 9.49974 6.50293 9.53125C6.58382 9.59451 6.70738 9.68229 6.86914 9.77051C7.19309 9.94712 7.66321 10.123 8.25 10.123C8.83696 10.123 9.30704 9.94703 9.63086 9.77051C9.79231 9.68244 9.91626 9.59446 9.99707 9.53125C10.0368 9.50012 10.0662 9.47488 10.084 9.45898C10.092 9.45183 10.0983 9.44641 10.1016 9.44336Z"
        fill="currentColor"
      />
      <path d="M10.1025 9.44238L10.1035 9.44043C10.1032 9.44075 10.1034 9.44161 10.1025 9.44238Z" fill="currentColor" />
      <path
        d="M6.48047 5.79004C6.65489 5.57627 6.9696 5.54454 7.18359 5.71875C7.39749 5.89312 7.43005 6.20783 7.25586 6.42188C6.94021 6.80945 6.48473 7.05468 5.98242 7.05469C5.47524 7.05457 5.03392 6.805 4.71582 6.42871L5.09766 6.10645L5.47949 5.7832C5.64506 5.97905 5.82305 6.05457 5.98242 6.05469C6.14689 6.05468 6.32997 5.97483 6.48047 5.79004Z"
        fill="currentColor"
      />
      <path
        d="M11.0146 5.79004C11.189 5.57625 11.5037 5.54477 11.7178 5.71875C11.9317 5.89316 11.9643 6.20782 11.79 6.42188C11.4744 6.80939 11.0189 7.05469 10.5166 7.05469C10.0096 7.05442 9.568 6.80489 9.25 6.42871L9.63184 6.10645L10.0137 5.7832C10.1791 5.97886 10.3573 6.05443 10.5166 6.05469C10.681 6.05469 10.8642 5.97477 11.0146 5.79004Z"
        fill="currentColor"
      />
      <path
        d="M4.77441 5.72461C4.98527 5.54647 5.30123 5.57245 5.47949 5.7832L4.71582 6.42871C4.5378 6.21799 4.56403 5.90292 4.77441 5.72461Z"
        fill="currentColor"
      />
      <path
        d="M9.30859 5.72461C9.51937 5.54643 9.83535 5.57263 10.0137 5.7832L9.25 6.42871C9.07226 6.21805 9.09845 5.90288 9.30859 5.72461Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.25 1.5C11.8399 1.5 14.75 4.41015 14.75 8C14.7499 11.5897 11.8398 14.5 8.25 14.5C4.66029 14.4999 1.75013 11.5897 1.75 8C1.75 4.41019 4.66021 1.50007 8.25 1.5ZM8.25 2.75C5.35056 2.75007 3 5.10055 3 8C3.00013 10.8993 5.35064 13.2499 8.25 13.25C11.1494 13.25 13.4999 10.8994 13.5 8C13.5 5.10051 11.1495 2.75 8.25 2.75Z"
        fill="currentColor"
      />
    </svg>
  );
};
export default Happy;
